// 根据环境做不同的域名
const ENV = process.env.NODE_ENV === 'development';
const ProdENV = process.env.UMI_ENV === 'prod';
const isProduct = window.location.origin.includes('mstore.mall.autohome.com.cn') 
|| window.location.origin.includes('store.mall.m.autohome.com.cn')
|| window.location.origin.includes('m.store.mall.autohome.com.cn');

// 测试
let HOST = ENV ? 'api' : '';

const moduleUrl = '';

// server
const apiPrefix = `${HOST}${moduleUrl}`;
// const apiPrefix = `${HOST}`;

export const base = {
  HOST,
  // PublicPath,
  apiPrefix,
  moduleUrl,
  ENV,
  ProdENV,
  isProduct
};
